import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSidebarSimpleRightSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"sidebar-simple-right-square"} maskId="square-filled-radius-0-stroke-1-IconSidebarSimpleRightSquare"><path fillRule="evenodd" clipRule="evenodd" d="M21 3H3V21H21V3ZM15 4V20H4V4H15Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSidebarSimpleRightSquare;
